//components
import Header from './compomnent/Header';
import Body from './compomnent/Body';
import Footer from "./compomnent/Footer"
//styles
import './App.css';
import "./compomnent/styles/header.scss"
import "./compomnent/styles/footer.scss"
import "./compomnent/styles/body.scss"
function App() {
  return (
    <div className="App">
      <Header/>
      <Body/>
      <Footer/>

    </div>
  );
}

export default App;
